import { render, staticRenderFns } from "./index_page.vue?vue&type=template&id=67073de1&scoped=true&"
import script from "./index_page.vue?vue&type=script&lang=js&"
export * from "./index_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67073de1",
  null
  
)

export default component.exports